import Papa from "papaparse";
import {formatDate} from "@/utils/DateUtils";
import {SetStateFn} from "@/utils/SetStateUtils";
import {EmployeeInReport} from "@/data/entities/employee";
import {DateRange} from "react-day-picker";
import {NotifyFn} from "peggirkit";
import {IntlShape} from "react-intl";
import { RestaurantLocation } from "@/data/entities/restaurant";

export const minutesToDecimalHours = (minutes: number): number =>
    Number((minutes / 60).toFixed(2));

export const getWorkedMinutes = (clockIn: string, clockOut: string): number => {
    return Math.round(
        (new Date(clockOut).getTime() - new Date(clockIn).getTime()) / 1000 / 60
    );
};

type ExportCsvProps = {
    setLoading: SetStateFn<boolean>,
    setShow: SetStateFn<boolean>,
    data: EmployeeInReport[],
    dashboardLocation: RestaurantLocation,
    dateRange: DateRange,
    notify: NotifyFn,
    intl: IntlShape,
};

export const exportCsv = async ({
                                    setLoading,
                                    data,
                                    dashboardLocation,
                                    dateRange,
                                    setShow,
                                    notify,
                                    intl
                                }: ExportCsvProps) => {
    setLoading(true);
    try {
        const rows = data.map(employee => {
            const totalClockedMinutes = employee.timeEntries.reduce(
                (total, entry) => {
                    if (!entry.clockOut) {
                        return total;
                    }

                    return total + getWorkedMinutes(
                        entry.clockIn,
                        entry.clockOut
                    );
                },
                0
            );

            const totalBreakMinutes = employee.timeEntries.reduce(
                (total, entry) => total + entry.breakMinutes,
                0
            );

            const totalWorkedMinutes =
                totalClockedMinutes - totalBreakMinutes;

            return {
                Naam: `${employee.firstName} ${employee.lastName}`,
                "Ingeklokte uren": minutesToDecimalHours(totalClockedMinutes),
                "Pauze uren": minutesToDecimalHours(totalBreakMinutes),
                "Gewerkte uren": minutesToDecimalHours(totalWorkedMinutes),
            };
        });

        const csv = Papa.unparse(rows);

        const blob = new Blob(
            ["\ufeff" + csv],
            {type: "text/csv;charset=utf-8;"}
        );

        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Export ${dashboardLocation.name} ${formatDate(dateRange.from!)}-${formatDate(dateRange.to!)}.csv`;
        link.click();

        URL.revokeObjectURL(url);

        setShow(false);
        notify({message: intl.formatMessage({id: "downloadStartsImmediately"})})
    } finally {
        setLoading(false);
    }
};